import * as React from 'react';
import { DrawerContentScrollView, DrawerItemList, DrawerItem } from '@react-navigation/drawer';
import { Picker, Image, ImageBackground, Platform } from 'react-native';
import { Content, Text, List, ListItem, Icon, Container, Left, Right, Badge, Button, View, StyleProvider, getTheme, variables, Item, Thumbnail, Body, Separator, Footer, Header } from 'native-base';
import MaterialDrop from '../../components/materialDrop';
import * as Updates from 'expo-updates';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useRoute } from '@react-navigation/native';
import Constants from 'expo-constants';
import Alert from '../alert';
import LocalStorage from '../../api/LocalStorage';
import AppDef from '../../../app.json';

const drawerCover = Platform.OS == 'web' ? require('../../../assets/drawer-calcal.png') : require('../../../assets/drawer-tax.jpg');
const drawerImage = require('../../../assets/logo-mobile-app.png');

import styles from './style';

export default function CustomDrawerContent(props) {
	const { vatReg, userInfo } = useSelector(
		state => ({
			vatReg: state.globalReducer.busDetails.vatRegistered,
			userInfo: state.loginReducer.userInfo
		}),
		shallowEqual
	);

	const { demo_id, freeLevel, thumbPath, display_name } = userInfo ? userInfo.user : {};
	//console.log(Updates);
	const { version, sdkVersion, revisionId } = Platform.OS == 'web' ? Constants.manifest : Updates.manifest.version ? Updates.manifest : AppDef.expo;

	const dropActions = demo_id ? ['Log Out'] : ['Profile', 'Payment Level', 'Change PIN', 'Log Out'];

	const userTap = (i, e) => {
		__DEV__ && console.log(i);
		if (i == 'Payment Level') Platform.OS == 'web' ? (window.location = 'https://calcal.uk/membership-account/') : props.navigation.navigate({ name: 'SubscriptionContainer' });
		if (i == 'Profile') Platform.OS == 'web' ? (window.location = 'https://calcal.uk/your-profile/') : props.navigation.navigate({ name: 'Profile' });
		if (i == 'Change PIN') props.navigation.navigate({ name: 'Pin', params: { change: 'change' } });
		if (i == 'Log Out') logOut();
	};

	const dispatch = useDispatch();
	const logOut = () => {
		if (Platform.OS == 'web') return actuallyLogout();
		Alert.alert(
			'Logging Out',
			'Do you want to log out of the App?',
			[
				{ text: 'Cancel', style: 'cancel' },
				{
					text: 'Log Out',
					onPress: actuallyLogout
				}
			],
			{ cancelable: true }
		);
	};

	const actuallyLogout = () => {
		LocalStorage.removeUserAsync();
		dispatch({
			type: 'CLEAR_USER'
		});
		if (Platform.OS == 'web') {
			window.location = 'https://calcal.uk/log-out';
		} else {
			Updates.reloadAsync();
		}
	};

	const itemTap = route => {
		props.navigation.navigate(route);
	};

	const icon = ({ focused, color, size }, icon) => <Icon style={focused ? styles.icon : styles.inactiveIcon} color={color} size={size} name={icon} />;

	const showVat = vatReg && !freeLevel;
	//console.log(props.state);

	const stackNav = props.state && props.state.index == 0 && props.state.routes[0].state;

	const tabNav = stackNav && stackNav.index == 0 && stackNav.routes[0].state;

	const routeName = tabNav && tabNav.routeNames && tabNav.routeNames[tabNav.index];
	//console.log(routeName);

	return (
		<>
			{false && props.fixed && (
				<Header>
					<Body></Body>
				</Header>
			)}
			<ImageBackground source={drawerCover} style={styles.drawerCover}>
				{!props.fixed && Platform.OS == 'web' && (
					<Button transparent style={{ alignSelf: 'flex-start', paddingTop: 30, paddingLeft: 0 }} onPress={() => props.navigation.closeDrawer()}>
						<Icon name="menu" style={{ fontSize: 28, paddingRight: 2, color: '#FFF' }} />
					</Button>
				)}
				<View />
				<Image square style={styles.drawerImage} source={drawerImage} />

				<MaterialDrop uri={thumbPath} text={display_name} actions={dropActions} onPress={(e, i) => userTap(dropActions[i])} destructiveButtonIndex={3} />
			</ImageBackground>
			<DrawerContentScrollView {...props}>
				{false && <DrawerItemList {...props} />}

				<DrawerItem {...props} focused={routeName === 'Years'} label="Self-Assessment" onPress={() => itemTap('Years')} icon={x => icon(x, 'document')} />
				<View style={{ height: 1, backgroundColor: '#c9c9c9' }} />
				{false && <DrawerItem {...props} focused={props.state.index == 1} label="Settings" onPress={() => itemTap('Settings')} icon={x => icon(x, 'settings')} />}
				<DrawerItem label="Log Out" onPress={() => logOut()} icon={x => icon(x, 'lock')} />

				{__DEV__ && (
					<Separator bordered style={{ height: 1 }}>
						<Text>
							Dev mode SDK {sdkVersion} {revisionId}
						</Text>
					</Separator>
				)}
			</DrawerContentScrollView>
			<Footer style={{ backgroundColor: 'transparent' }}>
				<Body style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around' }}>
					<Text note>© CalCal Ltd.</Text>
					<Button
						transparent
						onPress={() => {
							//Sentry.captureException(new Error('Oops!'));
							Updates.reloadAsync();
						}}>
						<Text note style={{ margin: 10, height: 20 }}>
							Version {version}
						</Text>
					</Button>
				</Body>
			</Footer>
		</>
	);
}
